import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-channels-selector',
    templateUrl: './channels-selector.component.html',
    styleUrls: ['./channels-selector.component.scss'],
    standalone: false
})
export class ChannelsSelectorComponent implements OnInit {

  @Input('isMobile') isMobile: boolean = false;
  @Input('isChild') isChild: boolean = false;
  @Input('formGroup') formGroup!: UntypedFormGroup;

  constructor() { }

  ngOnInit(): void {
    // no initial operations required
  }

}
